import { render, staticRenderFns } from "./FormationSave.vue?vue&type=template&id=351c2b46&scoped=true"
import script from "./FormationSave.vue?vue&type=script&lang=js"
export * from "./FormationSave.vue?vue&type=script&lang=js"
import style0 from "./FormationSave.vue?vue&type=style&index=0&id=351c2b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c2b46",
  null
  
)

export default component.exports